import { NgModule } from '@angular/core';
import { EDITOR_SERVICE } from '@core/injection-tokens/editor.injection.token';
import { StoreModule } from '@ngrx/store';
import { MojoAutocompleteModule } from 'mojo-autocomplete';
import { MojoAvatarModule } from 'mojo-avatar';
import { MojoCardModule } from 'mojo-card';
import { MojoEditorModule } from 'mojo-editor';
import { MojoShareResourceModule } from 'mojo-share-resource';
import { QuillModule } from 'ngx-quill';

import {
  AVATAR_CONFIG_SERVICE,
  AVATAR_DOWNLOAD_SERVICE,
} from '@core/injection-tokens/avatar.injection.token';
import {
  SHARE_RESOURCE_AUTOCOMPLETE_SERVICE,
  SHARE_RESOURCE_SERVICE,
  SHARE_TEAM_MEMBER_SERVICE,
} from '@core/injection-tokens/share-resource.injection.token';
import { MaterialModule } from '@material/material.module';

import { SharedModule } from '@shared';
import { MojoNumericInputModule } from '@shared/mojo-numeric-input/mojo-numeric-input.module';
import { MultipleLocationInputModule } from '@shared/multiple-location/multiple-location-input.module';

import {
  JobBasicFormComponent,
  JobDescriptionFormComponent,
  JobSalaryDirectComponent,
  JobSalaryFullTimeFormComponent,
  JobSalaryPartTimeFormComponent,
  JobSalaryTemporaryContractFormComponent,
  JobStatusFormComponent,
} from './components';
import { JobFormComponent } from './containers/job-form/job-form.container';
import { JobFormRoutingModule } from './job-form-routing.module';
import { jobFormReducer } from './store';
import { JobFormGuard } from '@shared/job-form/guards/job-form.guard';
import { JobEditPageComponent } from '@shared/job-form/containers/page/job-edit-page.component';

const components = [
  JobFormComponent,
  JobBasicFormComponent,
  JobDescriptionFormComponent,
  JobStatusFormComponent,
];

@NgModule({
  imports: [
    QuillModule,
    SharedModule,
    MaterialModule,
    MultipleLocationInputModule,
    JobFormRoutingModule,
    MojoAutocompleteModule,
    StoreModule.forFeature('jobForm', jobFormReducer),
    MojoAvatarModule,
    MojoShareResourceModule.forRoot(
      SHARE_RESOURCE_SERVICE,
      SHARE_RESOURCE_AUTOCOMPLETE_SERVICE,
      AVATAR_DOWNLOAD_SERVICE,
      AVATAR_CONFIG_SERVICE,
      SHARE_TEAM_MEMBER_SERVICE,
    ),
    MojoCardModule,
    MojoNumericInputModule,
    MojoEditorModule.forRoot(EDITOR_SERVICE),
  ],
  providers: [JobFormGuard],
  declarations: [
    components,
    JobSalaryFullTimeFormComponent,
    JobSalaryTemporaryContractFormComponent,
    JobSalaryPartTimeFormComponent,
    JobSalaryDirectComponent,
    JobEditPageComponent,
  ],
  exports: components,
})
export class JobsFormModule {}
